import store from '../../store';
import { userClearAction } from '../../store/user';
import Environment from '../Environment';

export default class API {
  submit(path, method, body) {
    return this.fetch(path, method, JSON.stringify(body));
  }

  fetch(path, method = 'GET', body = undefined, contentType = 'application/json', options = {}) {
    const fetchOptions = {
      method,
      body,
      redirect: 'follow',
      credentials: 'include',
      headers: {}
    };

    if (contentType) {
      fetchOptions.headers['Content-Type'] = contentType;
    }

    const request = new Request(Environment.API + path, fetchOptions);

    return fetch(request).then((response) => {
      if (response.status === 401) {
        store.dispatch(userClearAction());
      }
      return response;
    });
  }
}
